/** The only chrome left in TV mode: says how to leave, and leaves on click. */
export function TvChip({ onExit }: { onExit: () => void }) {
  return (
    <button
      type="button"
      onClick={onExit}
      className="absolute right-4 top-4 z-20 rounded-full border border-line bg-surface-1/80 px-3 py-1 font-display text-2xs font-bold uppercase tracking-[0.08em] text-ink-muted backdrop-blur-sm hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-signal"
    >
      TV · press Esc
    </button>
  );
}
